/**
 * @file EULAPage.js
 * @description This file contains the EULAPage component, which allows users to review and agree to the Terms of Use.
 */
import React, { useState } from 'react';
import styles from './OnboardingPage.module.scss';
import Spinner from '../ui/spinners/Spinner';
import { IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { getText } from '../../i18n';
const EULAPage = ({ companyConfig, onEULAAgree }) => {
    const termsOfUseUrl =
        companyConfig?.terms_of_use_url ||
        'https://ingaged-dev-ingress.ext.dv.aws-uset1.oss2.mrshmc.com/v1/files/asset/static/tnc.txt';
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    const handleIframeLoad = () => {
        setIsLoading(false);
    };

    const handleIframeError = () => {
        setIsLoading(false);
        setError('Failed to load Terms of Use content.');
    };

    const handleAgree = () => {
        onEULAAgree();
    };

    const BackNavIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="27"
            height="27"
            viewBox="0 0 30 30"
            fill="none"
        >
            <g clip-path="url(#clip0_77225_1906)">
                <path
                    d="M12.5 27.5L0 15L12.5 2.5L14.7188 4.71875L4.4375 15L14.7188 25.2813L12.5 27.5Z"
                    fill="#2F2B43"
                />
            </g>
            <defs>
                <clipPath id="clip0_77225_1906">
                    <rect width="30" height="30" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );

    return (
        <div className={`${styles.eulaContainer} d-flex flex-column pt-3 px-3`}>
            <h2 className="iNGAGED-Typography-Heading3 mb-3">{getText('msg_d32cbb0b2df6')}</h2>

            {isLoading && (
                <div className={`${styles.eulaContent} px-3`}>
                    <Spinner className={styles.loadingSpinner} width={50} />
                </div>
            )}

            {error ? (
                <div className={`${styles.eulaContent} px-3`}>{error}</div>
            ) : (
                <iframe
                    src={termsOfUseUrl}
                    className={styles.eulaContent}
                    title={getText('msg_97738411d629')}
                    style={{
                        border: 'none',
                        width: '100%',
                        display: isLoading ? 'none' : 'block',
                    }}
                    onLoad={handleIframeLoad}
                    onError={handleIframeError}
                />
            )}

            {onEULAAgree && ( // Conditionally render the agree button container
                <div className={`${styles.agreeButtonContainer} col-auto my-3`}>
                    <small className={styles.acceptTerms}>
                        {getText('msg_f47e0640e96b')}
                    </small>
                    <button
                        className="ing-button-primary-left mx-auto my-3 mt-4"
                        onClick={handleAgree}
                        disabled={isLoading}
                    >
                        {getText('msg_ee68d3496bb4')}
                    </button>
                </div>
            )}

            {!onEULAAgree && (
                <div className="back-nav-iconPDF">
                    <Link to={ROUTES.PROFILE}>
                        <IconButton>
                            <BackNavIcon />
                        </IconButton>
                    </Link>
                </div>
            )}
        </div>
    );
};

export default EULAPage;
